// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_CriarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /plano_metas/criar
 *
 * Validates monthly goal plan creation requests. Creates a new plano de metas
 * for a franchise with the specified start date (data_final is auto-calculated
 * as end of month).
 */
import { registerContract } from './validate'

export interface PlanoMetas_CriarInput {
franquia_id: number
data_inicial: string
meta_faturamento?: number
meta_clientes?: number
}

registerContract('PlanoMetas_CriarInput', {
  franquia_id:      { type: 'number',  required: true },
  data_inicial:     { type: 'string',  required: true },
  meta_faturamento: { type: 'number',  required: false },
  meta_clientes:    { type: 'number',  required: false },
})
